.fileUploader {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.fileInput {
  flex: 18;
  display: flex;
  align-items: center;
  min-width: 128px;

  &>input {
    width: 100%;
  }
}

.editNameButton {
  flex: 0;
}

.uploadButton {
  flex: 2;
}